import React, { useMemo } from 'react';
import { Select, Alert, Spin } from "antd";
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "../../store/actions/index";
import FormItem from '../FormItem/FormItem';
import Form from '../Form/Form';
import FormButtons from '../FormButtons/FormButtons';
import Fieldset from '../FormFieldset/FormFieldset';
import { isObjectNotEmpty } from '../../shared/objectUtils';

const { Option } = Select;

const EditLoadRepresentative = ({ load, users, cancel }) => {
    const methods = useForm({ mode: 'all', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.loads.isRecordUpdateLoading);
    const error = useSelector(state => state.loads.updateRecordError);

    const onSubmit = (data) => {
        if (isObjectNotEmpty(data)) {
            dispatch(actionCreators.updateLoad(load.id, data))
        } else {
            onCancel();
        }
    };

    const onCancel = () => {
        dispatch(actionCreators.updateLoadCancel());
        cancel();
    };

    useMemo(() => {
        // clear any previous errors if this is a new form
        dispatch(actionCreators.updateLoadErrorClear());
    }, []);

    useMemo(() => {
        if (isLoading !== null && isLoading === false && error === null) {
            onCancel();
        }
    }, [isLoading, error]);

    const formItemLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onSubmit)}>
                <Spin style={{ height: '100%', width: '100%' }} size="large" spinning={isLoading === true && error === null}>
                    <Fieldset legend="Update the Representative for this Load">
                        <FormItem {...formItemLayout} label="Representatives" required
                            render={({ onChange, onBlur, value, name, ref }) => (
                                <Select
                                    mode="multiple"
                                    placeholder="Please Select a Representative"
                                    allowClear={true}
                                    style={{ width: '100%' }}
                                    virtual={false}
                                    onBlur={onBlur}
                                    onChange={(selected) => { onChange(selected); }}
                                    value={value}
                                    name={name}
                                    ref={ref}
                                >
                                    {users.map(i => <Option value={i.user_id} key={i.user_id}>{i.firstName + ' ' + i.lastName}</Option>)}
                                </Select>
                            )}
                            rules={{ required: 'Required Field' }}
                            name='assignedAccountRepUserIds'
                            defaultValue={load && load.assignedAccountRepUserIds ? load.assignedAccountRepUserIds : null}
                        />
                    </Fieldset>
                    {error && <Alert message={`${error}`} type="error" />}
                </Spin>
                <FormButtons cancel={onCancel} disabled={isLoading === true && error === null} submitText="Update Representative" />
            </Form>
        </FormProvider>
    );
};

export default EditLoadRepresentative;